import { render } from "./index.vue?vue&type=template&id=4b6452ac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4b6452ac&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=4b6452ac&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b6452ac"]])

export default __exports__